package org.gstechnovos.jexonplastech.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.gstechnovos.jexonplastech.components.SectionTitle
import org.gstechnovos.jexonplastech.components.SkillBar
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Skill
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.AboutImageStyle
import org.gstechnovos.jexonplastech.styles.AboutTextStyle
import org.gstechnovos.jexonplastech.util.AnimatePercentage
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.ObserveViewportEntered
import org.gstechnovos.jexonplastech.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun AboutUsSection() {
    Box(
        modifier = Modifier.id(Section.About.id).maxWidth(SECTION_WIDTH.px).padding(topBottom = 150.px),
        contentAlignment = Alignment.Center
    ) {
        AboutContent()
    }
}

@Composable
fun AboutContent() {
    val breakPoint = LocalBreakpoint.current

    Column(
        modifier = Modifier.fillMaxWidth(if (breakPoint >= Breakpoint.MD) 80.percent else 90.percent)
            .maxWidth(1200.px), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SimpleGrid(
            modifier = Modifier.fillMaxWidth(if (breakPoint >= Breakpoint.MD) 90.percent else 100.percent)
                // This adds 20px spacing between items, regardless of layout direction
                .gap(20.px), numColumns = numColumns(base = 1, md = 2)
        ) {
            if (breakPoint >= Breakpoint.MD) AboutImage()
            AboutMe()
        }
    }
}

@Composable
fun AboutImage() {

    Box(modifier = Modifier.fillMaxHeight().fillMaxSize(), contentAlignment = Alignment.Center) {
        Image(
            modifier = AboutImageStyle.toModifier().fillMaxWidth(80.percent),
            src = Res.Image.ABOUT_IMAGE,
            description = "About Image"
        )
    }
}

@Composable
fun AboutMe() {
    val scope = rememberCoroutineScope()
    var viewportEntered by remember { mutableStateOf(false) }

    val animatedPercentage = remember { mutableStateListOf(0, 0, 0, 0, 0) }

    ObserveViewportEntered(
        sectionId = Section.About.id,
        distanceFromTop = window.innerHeight / 2.0,      // Adjusts sensitivity (how far into view before triggering)
        onViewportEntered = {
            viewportEntered = true
            Skill.entries.forEach { skill ->
                scope.launch {
                    AnimatePercentage(
                        percentage = skill.percentage.value.toInt(), onUpdate = {
                            animatedPercentage[skill.ordinal] = it
                        })
                }
            }
        })

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.Center,
    ) {
        SectionTitle(section = Section.About)

        P(
            attrs = AboutTextStyle.toModifier().margin(topBottom = 15.px).maxWidth(500.px)
                .fontFamily(Constants.FONT_FAMILY).fontSize(18.px).fontWeight(
                    FontWeight.Normal
                ).fontStyle(FontStyle.Italic).color(Theme.Secondary.rgb).toAttrs()
        ) {
            Text(Constants.aboutDescription)
        }

        Skill.entries.toTypedArray().forEach { skill ->
            SkillBar(
                name = skill.title,
                index = skill.ordinal,
                percentage = if (viewportEntered) skill.percentage else 0.percent,
                animatePercentage = if (viewportEntered) animatedPercentage[skill.ordinal] else 0
            )
        }
    }
}